// Used in avenue-assets.component.ts

// Angular
import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    OnInit,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

// RXJS/Store
import * as createStore from "#components/content-library/assign-cart/content-builder-store";
import * as LoginStore from "#login/store";
import { Store, select } from "@ngrx/store";
import { Observable } from "rxjs";

// Services/Types/Helpers
import { SubjectId } from "@carnegie-learning/common-types";
import { AssetAssociation, Perform } from "@carnegie-learning/cure-types";

export interface DialogData {
    asset: Perform;
    subjectId: SubjectId;
    assetAssociation: AssetAssociation;
}

@Component({
    selector: "avenue-asset-dialog",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./avenue-asset-dialog.component.html",
    styleUrls: ["./avenue-asset-dialog.component.scss"],
    standalone: false
})
export class AvenueAssetDialogComponent implements OnInit {
    userGUID$?: Observable<any>;
    performAsset: Perform;
    subjectId?: SubjectId;
    assetAssociation?: AssetAssociation | undefined;

    constructor(
        private loginStore: Store<LoginStore.UserState>,
        private store_create: Store<createStore.CreateState>,
        public dialogRef: MatDialogRef<AvenueAssetDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {}

    ngOnInit() {
        this.userGUID$ = this.loginStore.pipe(select(LoginStore.getUserGUID));

        if (this.data.subjectId) {
            this.subjectId = this.data.subjectId;
        }
        if (this.data.assetAssociation) {
            this.assetAssociation = this.data.assetAssociation;
        }

        if (this.data.asset) {
            this.performAsset = this.data.asset;
        }
    }

    onCreate(event: Perform) {
        this.store_create.dispatch(createStore.createAsset({ payload: event }));
        this.dialogRef.close(event); // Pass this out to the beforeClosedHandler
    }

    onUpdate(event: Perform) {
        this.store_create.dispatch(createStore.updateAsset({ payload: event }));
        this.dialogRef.close(event); // Pass this out to the beforeClosedHandler
    }

    onCancel() {
        this.dialogRef.close();
    }
}
